import { DOMESTIC_NUTRITION_KEYS } from "../../Utils/constants.js"
import {
  BaseLabelJSON,
  InterleavedOtherNutrient,
} from "../../constants/exportsCountries.js"

interface SingaporeMandatoryNutrients {
  ENERGY: string
  TOTAL_CARBOHYDRATE: string
  PROTEIN: string
  TOTAL_FAT: string
  TRANS_FAT: string
}

export const SINGAPORE_MANDATORY_NUTRIENTS: SingaporeMandatoryNutrients = {
  ENERGY: DOMESTIC_NUTRITION_KEYS.ENERGY,
  TOTAL_CARBOHYDRATE: DOMESTIC_NUTRITION_KEYS.TOTAL_CARBOHYDRATE,
  PROTEIN: DOMESTIC_NUTRITION_KEYS.PROTEIN,
  TOTAL_FAT: DOMESTIC_NUTRITION_KEYS.TOTAL_FAT,
  TRANS_FAT: DOMESTIC_NUTRITION_KEYS.TRANS_FAT,
}

export const SINGAPORE_NON_MANDATORY_NUTRIENTS = [
  {
    key: DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE,
    value: "Dietary Fibre",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.TOTAL_SUGARS,
    value: "Total Sugars",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.ADDED_SUGARS,
    value: "Added Sugars",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.SODIUM,
    value: "Sodium",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.SATURATED_FAT,
    value: "Saturated Fat",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.TRANS_FAT,
    value: "Trans Fat",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.CHOLESTEROL,
    value: "Cholesterol",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.TOTAL_SUGARS,
    value: "Total Sugars",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.ORYZANOL,
    value: "Oryzanol",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.IRON,
    value: "Iron",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.CALCIUM,
    value: "Calcium",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.FOLIC_ACID,
    value: "Folic Acid",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.IODINE,
    value: "Iodine",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_B6,
    value: "Vitamin B6",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_B12,
    value: "Vitamin B12",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_C,
    value: "Vitamin C",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.ZINC,
    value: "Zinc",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.MAGNESIUM,
    value: "Magnesium",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_D,
    value: "Vitamin D",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_K1,
    value: "Vitamin K1",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_B1,
    value: "Vitamin B1",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_B2,
    value: "Vitamin B2",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.BIOTIN,
    value: "Biotin",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_B3,
    value: "Vitamin B3",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.PANTOTHENIC_ACID,
    value: "Pantothenic Acid",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_E,
    value: "Vitamin E",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_A,
    value: "Vitamin A",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.SELENIUM,
    value: "Selenium",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.COPPER,
    value: "Copper",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.POTASSIUM,
    value: "Potassium",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.CHLORIDE,
    value: "Chloride",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.MANGANESE,
    value: "Manganese",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.PHOSPHORUS,
    value: "Phosphorus",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.MUFA,
    value: "MUFA",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.PUFA,
    value: "PUFA",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.OMEGA_3_FATTY_ACIDS,
    value: "Omega 3 Fatty Acids",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.OMEGA_6_FATTY_ACIDS,
    value: "Omega 6 Fatty Acids",
    unit: "g",
  },
]

export const SINGAPORE_NON_MANDATORY_NUTRIENTS_EXCEPT_TRANS_FAT = [
  {
    key: DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE,
    value: "Dietary Fibre",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.TOTAL_SUGARS,
    value: "Total Sugars",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.ADDED_SUGARS,
    value: "Added Sugars",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.SODIUM,
    value: "Sodium",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.SATURATED_FAT,
    value: "Saturated Fat",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.CHOLESTEROL,
    value: "Cholesterol",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.TOTAL_SUGARS,
    value: "Total Sugars",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.ORYZANOL,
    value: "Oryzanol",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.IRON,
    value: "Iron",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.CALCIUM,
    value: "Calcium",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.FOLIC_ACID,
    value: "Folic Acid",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.IODINE,
    value: "Iodine",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_B6,
    value: "Vitamin B6",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_B12,
    value: "Vitamin B12",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_C,
    value: "Vitamin C",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.ZINC,
    value: "Zinc",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.MAGNESIUM,
    value: "Magnesium",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_D,
    value: "Vitamin D",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_K1,
    value: "Vitamin K1",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_B1,
    value: "Vitamin B1",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_B2,
    value: "Vitamin B2",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.BIOTIN,
    value: "Biotin",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_B3,
    value: "Vitamin B3",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.PANTOTHENIC_ACID,
    value: "Pantothenic Acid",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_E,
    value: "Vitamin E",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.VITAMIN_A,
    value: "Vitamin A",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.SELENIUM,
    value: "Selenium",
    unit: "mcg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.COPPER,
    value: "Copper",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.POTASSIUM,
    value: "Potassium",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.CHLORIDE,
    value: "Chloride",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.MANGANESE,
    value: "Manganese",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.PHOSPHORUS,
    value: "Phosphorus",
    unit: "mg",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.MUFA,
    value: "MUFA",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.PUFA,
    value: "PUFA",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.OMEGA_3_FATTY_ACIDS,
    value: "Omega 3 Fatty Acids",
    unit: "g",
  },
  {
    key: DOMESTIC_NUTRITION_KEYS.OMEGA_6_FATTY_ACIDS,
    value: "Omega 6 Fatty Acids",
    unit: "g",
  },
] as const

export interface ConsumerCareInfo {
  consumercare_addr_same_as_manufactured?: string
  address?: string
  email?: string
  phone?: string
  website?: string
}

export interface StorageInstructions {
  instructions_of_use?: string
  storage_instructions_text?: string
}

export interface LabelJson {
  [key: string]: any
  vegetarian_and_non_vegetarian?: string
  brandId?: string
  food_name?: string
  consumer_care?: ConsumerCareInfo[]
  use_storage_instructions?: StorageInstructions[]
  country_of_origin?: string
  batch_number_title?: { batch_no?: string }[]
  date_of_pkg_mfg_title: {
    dateOf_packaging_manufacture: string
    typeOf_packaging_manufacture: string
    [key: string]: any
  }[]
  useBy_expiry_title: {
    typeOf_useBy_expiry: string
    dateOf_useBy_expiry: string
    [key: string]: any
  }[]
  mrp_title?: { mrp?: string }[]
  usp_title?: { usp_rs?: string; usp_unit?: string }[]
  add_barcode?: string
  bar_code?: string
  barcode_number?: string
  imported_by?: string
  expiry_durability_3_months: string
  flavour?: string
  other_information?: string
}

export interface BackOfPackSingaporeRightProps {
  data: { label_json?: LabelJson }
  showPreview: boolean
  userAddress: any
}

export interface FrontOfPackSingaporeProps {
  data: { label_json?: LabelJson }
  brandsMapping: Record<string, any>
}

export const EDIBLE_FAT_OR_EDIBLE_OIL_CATEGORIES: string[] = [
  "2.1.1",
  "2.1.2",
  "2.1.3",
  "2.2.1",
  "2.2.2",
  "2.3",
  "2.4.1",
]

interface Nutrient {
  key: string
  name: string
  per_serve: number | string
  per_100g: number | string
  unit?: string
}

export interface SingaporeNiTableCalculatedValue {
  serving_size: number
  country: string
  serving_size_unit: string
  no_of_servings: number
  household_quantity: string
  servings_per_package: number
  mandatory_nutrient_values: {
    ENERGY: Nutrient
    CARBOHYDRATE: Nutrient
    PROTEIN: Nutrient
    FAT: Nutrient
    TRANS_FAT?: Nutrient
  }
  non_mandatory_nutrient_values: Nutrient[]
}

export interface SingaporeLabelJson extends BaseLabelJSON {
  ni_table_calculated_values: SingaporeNiTableCalculatedValue
}

export const SINGAPORE_INTERLEAVED_NUTRIENTS: InterleavedOtherNutrient[] = [
  { name: "SATURATED_FAT", key: DOMESTIC_NUTRITION_KEYS.SATURATED_FAT },
  { name: "TRANS_FAT", key: DOMESTIC_NUTRITION_KEYS.TRANS_FAT },
  { name: "CHOLESTEROL", key: DOMESTIC_NUTRITION_KEYS.CHOLESTEROL },
  { name: "MUFA", key: DOMESTIC_NUTRITION_KEYS.MUFA },
  { name: "PUFA", key: DOMESTIC_NUTRITION_KEYS.PUFA },
  { name: "OMEGA_3", key: DOMESTIC_NUTRITION_KEYS.OMEGA_3_FATTY_ACIDS },
  { name: "OMEGA_6", key: DOMESTIC_NUTRITION_KEYS.OMEGA_6_FATTY_ACIDS },
  { name: "TOTAL_SUGAR", key: DOMESTIC_NUTRITION_KEYS.TOTAL_SUGARS },
  { name: "ADDED_SUGAR", key: DOMESTIC_NUTRITION_KEYS.ADDED_SUGARS },
  { name: "DIETARY_FIBER", key: DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE },
  { name: "SODIUM", key: DOMESTIC_NUTRITION_KEYS.SODIUM },
]
